import React, { useState, useEffect, useRef } from 'react';
// components
import ItemHeader from './ItemHeader';
import ItemButtonList from './ItemButtonList';
import ModalSetImg from './ModalSetImg';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';

const BasicCard = ({
    el,
    itemsIdx,
    onChangeTxt,
    changeBtnList,
    outputsEl,
    callbackFromParent,
    callBackhandleItem,
    maxLengthValueB,
    hasItem,
    fixedRatio,
}) => {
    // state
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [isOverflowModal, setOverflowModal] = useState(false);
    // title
    const changedTitleValue = el.title ? el.title.substring(0, 20) : '';
    // description
    if (hasItem > 1 && el.title) {
        maxLengthValueB = 40;
    }
    const changedDesValue = el.description
        ? el.description.substring(0, maxLengthValueB)
        : '';

    // 모달 위치
    const imgNode = useRef();
    // 모달 열기
    const openModal = () => {
        let ItemSetButtonPos = imgNode.current.getBoundingClientRect();
        let contentsWrap = imgNode.current.offsetParent.offsetParent.getBoundingClientRect();
        if (contentsWrap.right - ItemSetButtonPos.right < 241) {
            setOverflowModal(true);
        }
        setIsOpenModal(!isOpenModal);
    };
    // 모달 닫기
    const closeSet = (e) => {
        if (imgNode.current.contains(e.target)) {
            // inside click
            return;
        }
        setIsOpenModal(false);
    };
    // 모달 닫기
    useEffect(() => {
        // add when mounted
        document.addEventListener('mousedown', closeSet);
        // return function to be called when unmounted
        return () => {
            document.removeEventListener('mousedown', closeSet);
        };
    }, []);

    // 이미지
    let bgImgUrl = '';
    if (el.thumbnail) {
        bgImgUrl = el.thumbnail.imageUrl;
    }
    // 이미지 url 콜백
    const changeImgUrl = (imgUrl) => {
        bgImgUrl = imgUrl;
        if (!el.thumbnail) {
            el.thumbnail = {};
        }
        el.thumbnail.imageUrl = bgImgUrl;
        callbackFromParent(bgImgUrl);
    };
    // 버튼 백그라운드 이미지
    // const btnBg = {
    //     backgroundImage: 'url(' + bgImgUrl + ')',
    // };

    return (
        <div className="item-cont">
            <ItemHeader
                itemsIdx={itemsIdx}
                callBackhandleItem={callBackhandleItem}
                hasItem={hasItem}
            />
            <div className="item card">
                <div className="item-img-cont" ref={imgNode}>
                    <button
                        type="button"
                        onClick={openModal}
                        className={`${fixedRatio ? 'square' : ''}`}
                    >
                        {!bgImgUrl ? (
                            '+ 이미지 등록 '
                        ) : (
                            <img src={bgImgUrl} alt="카드 이미지" />
                        )}
                        {!bgImgUrl && <span>*</span>}
                    </button>
                    {isOpenModal && (
                        <ModalSetImg
                            outputsEl={outputsEl}
                            changeImgUrl={changeImgUrl}
                            isOverflowModal={isOverflowModal}
                            isCarousel={true}
                            el={el}
                            callbackFromParent={callbackFromParent}
                        />
                    )}
                </div>
                <div>
                    <div className="item-inp-cont">
                        <input
                            type="text"
                            placeholder="타이틀을 입력해주세요."
                            spellCheck="false"
                            className="title"
                            value={changedTitleValue}
                            onChange={onChangeTxt}
                            data-idx={itemsIdx}
                            maxLength="20"
                        />
                        <span>
                            <span>{changedTitleValue.length}</span>/20
                        </span>
                    </div>
                    <div className="item-inp-cont">
                        {/* <textarea
                            rows="2"
                            placeholder="텍스트를 입력해주세요."
                            spellCheck="false"
                            className="description"
                            value={changedDesValue}
                            onChange={onChangeTxt}
                            data-idx={itemsIdx}
                            maxLength={maxLengthValueB}
                        /> */}
                        <TextareaAutosize
                            rowsMin={2}
                            rowsMax={15}
                            placeholder="텍스트를 입력해주세요."
                            spellCheck="false"
                            className="description"
                            value={changedDesValue}
                            onChange={onChangeTxt}
                            data-idx={itemsIdx}
                            maxLength={maxLengthValueB}
                        />
                        <span>
                            <span>{changedDesValue.length}</span>/
                            {maxLengthValueB}
                        </span>
                    </div>
                    <ItemButtonList
                        outputsEl={outputsEl}
                        el={el}
                        index={itemsIdx}
                        changeBtnList={changeBtnList}
                        fixedRatio={fixedRatio}
                    />
                </div>
            </div>
        </div>
    );
};

export default BasicCard;
